import { withSpinner, success } from "../../../../redux/actions/utilities";
import {
  marketingAttributionReduxConstants,
  toastTypes,
} from "../../constants";
import { customToast } from "../../../../shared";
import { marketingAttributionServices } from "../../services";

const {
  DASHBOARD_MARKETING_ATTRIBUTION,
  GET_MARKETING_ATTRIBUTION_GRAPH_DATA,
  GET_MARKETING_ATTRIBUTION_REPORT_BODY,
  GET_MARKETING_ATTRIBUTION_PAGINATED_DATA,
} = marketingAttributionReduxConstants;

//Getting marketing attribution data for dashbard
const getMarketingAttributionData = (body) => {
  return (dispatch) => {
    withSpinner(dispatch, DASHBOARD_MARKETING_ATTRIBUTION, () =>
      marketingAttributionServices
        .getMarketingAttributionData(body)
        .then(
          (response) => {
            dispatch(success(response, DASHBOARD_MARKETING_ATTRIBUTION));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

const getMarketingAttributionPaginatedData = (body) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_MARKETING_ATTRIBUTION_PAGINATED_DATA, () =>
      marketingAttributionServices
        .getMarketingAttributionPaginatedData(body)
        .then(
          (response) => {
            dispatch(success(response, GET_MARKETING_ATTRIBUTION_PAGINATED_DATA));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

const getMarketingAttributionGraphData = (body) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_MARKETING_ATTRIBUTION_GRAPH_DATA, () =>
      marketingAttributionServices
        .getMarketingAttributionGraphData(body)
        .then(
          (response) => {
            dispatch(success(response, GET_MARKETING_ATTRIBUTION_GRAPH_DATA));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

const getMarketingAttributionReportBody = (deliveryId, taskQueueId) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_MARKETING_ATTRIBUTION_REPORT_BODY, () =>
      marketingAttributionServices
        .getMarketingAttributionReportBody(deliveryId, taskQueueId)
        .then(
          (response) => {
            dispatch(success(response, GET_MARKETING_ATTRIBUTION_REPORT_BODY));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

export const marketingAttributionActions = {
  getMarketingAttributionData,
  getMarketingAttributionGraphData,
  getMarketingAttributionReportBody,
  getMarketingAttributionPaginatedData,
};
